import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useCalendarMessages = () => {
  const [values, setValues] = useState(null);
  const { t } = useTranslation();

  if (!values) {
    setValues({
      date: t('CALENDAR.date'),
      time: t('CALENDAR.time'),
      event: t('CALENDAR.event'),
      allDay: t('CALENDAR.allDay'),
      week: t('CALENDAR.week'),
      work_week: t('CALENDAR.work_week'),
      day: t('CALENDAR.day'),
      month: t('CALENDAR.month'),
      previous: t('CALENDAR.previous'),
      next: t('CALENDAR.next'),
      yesterday: t('CALENDAR.yesterday'),
      tomorrow: t('CALENDAR.tomorrow'),
      today: t('CALENDAR.today'),
      agenda: t('CALENDAR.agenda'),
      noEventsInRange: t('CALENDAR.noEventsInRange'),
      showMore: total => `+${total} In più`,
    });
  }

  return values;
};

export { useCalendarMessages };
